import config from '@/config/index.js'
import axios from 'axios'
const env = require('../../env/index.js')

/**
 * @description: 创建axios实例
 * @param :
 * @return:
 */
const instance = axios.create({
  baseURL: env.baseURL,
  timeout: config.timeout
})

/**
 * @description:请求拦截器
 * @param :
 * @return:
 */
instance.interceptors.request.use(async config => {
  return config
}, error => {
  // console.log('request-error:', error)
  return Promise.reject(error)
})


/**
 * @description:响应拦截器
 * @param :
 * @return:
 */
instance.interceptors.response.use(response => {
  // console.log('response:', response)
  const { status } = response // 来自服务器响应的 HTTP 状态码
  if (status < 200 || status > 300) {
    return Promise.reject(response.data)
  } else {
    return Promise.resolve(response.data)
  }
}, error => {
  // 处理响应错误
  if (error.response) {
    // const { status } = error.response

    // switch (status) {
    //   case 1: { 
    //     break;
    //   }
    //   default:{
    //     var 
    //   }
    // }
    return Promise.reject(error.response.data)
  }
  if (error.code === 'ERR_NETWORK') {
    console.log('网络未连接，请稍后重试')
    return error
  }
  return Promise.reject(error)
})
export default instance
